module.exports = __webpack_public_path__ + "static/TuktukRed-8ec970b14cd4ade8e7c462838ea46b82.mp4";